export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";